import ChartWidget from './ChartWidget.vue';
import ContextWidget from './ContextWidget.vue';
import KpiWidget from './KpiWidget.vue';
import TableWidget from './TableWidget.vue';
import TextWidget from './TextWidget.vue';
import HeadingWidget from './HeadingWidget.vue';
import SheetWidget from './SheetWidget.vue';

function contextual(componentName) {
  return { name: `${componentName}Widget`, extends: ContextWidget, contextName: componentName, contextual: true };
}

export const STOCK_WIDGETS = {
  chart: ChartWidget,
  kpi: KpiWidget,
  table: TableWidget,
  text: TextWidget,
  heading: HeadingWidget,
  sheet: SheetWidget,
  'performance-trend': contextual('PerformanceTrend'),
  'peer-comparison': contextual('PerformanceCohort'),
  'performance-summary': contextual('PerformanceSummary'),
  'metric-alerts': contextual('ComposableAlertTable'),
  'metric-insights': contextual('MetricInsights'),
  'patient-worklist': contextual('PatientWorklist'),
};

export function stockComponent(name) {
  return STOCK_WIDGETS[name] || null;
}
